module.exports = __webpack_public_path__ + "static/img/game-Nihilumbra.c85c145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-Nihilumbra.jpg
// module id = kJXZ
// module chunks = 0